export default {
  name: 'audioDemo',
  component() {
    return {
      playing: false,
      active: 'processed', // lead with the processed sound — that's what sells the plugin
      init() {
        this.$refs.dry.muted = true
        this.$refs.processed.muted = false
        const reset = () => {
          this.playing = false
        }
        this.$refs.dry.addEventListener('ended', reset)
        this.$refs.processed.addEventListener('ended', reset)
      },
      toggle() {
        if (this.playing) {
          this.$refs.dry.pause()
          this.$refs.processed.pause()
          this.playing = false
        } else {
          Promise.all([this.$refs.dry.play(), this.$refs.processed.play()])
            .then(() => {
              this.playing = true
            })
            .catch(() => {
              this.playing = false
            })
        }
      },
      setActive(which) {
        if (which === this.active) return
        const from = this.active === 'dry' ? this.$refs.dry : this.$refs.processed
        const to = which === 'dry' ? this.$refs.dry : this.$refs.processed
        to.currentTime = from.currentTime // re-align so the A/B switch is instant, no drift
        this.active = which
        this.$refs.dry.muted = which !== 'dry'
        this.$refs.processed.muted = which !== 'processed'
      },
    }
  },
}
